import { render, staticRenderFns } from "./AfcodeList.vue?vue&type=template&id=ac56cbfe&scoped=true&"
import script from "./AfcodeList.vue?vue&type=script&lang=js&"
export * from "./AfcodeList.vue?vue&type=script&lang=js&"
import style0 from "./AfcodeList.vue?vue&type=style&index=0&id=ac56cbfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac56cbfe",
  null
  
)

export default component.exports